import { localise } from 'customHooks/useLocalised/useLocalised';
import * as textKeys from 'data/translationKeys';

export const signUpTexts = localise(
  Object.values(textKeys).map(textKey => textKey)
);
